// Agent definitions for the /agents/:id route. URLs come from frontend/.env
// (REACT_APP_JOTFORM_*) so they can be swapped per environment.
import { ACTIVATION_URL, RHEA_URL } from "@/lib/links";

export const AGENTS = {
  wellness: {
    id: "wellness",
    name: "Integrated Wellness Agent",
    role: "AI Health Concierge",
    avatar: "https://cdn.jotfor.ms/assets/agent-avatars/avatar_icon_82.png",
    blurb:
      "A private, always-on guide that listens, asks the right questions, and helps you map a personalized path to optimization, longevity, and superhuman performance.",
    url: process.env.REACT_APP_JOTFORM_WELLNESS_URL,
    cta: "Start the conversation",
  },
  rhea: {
    id: "rhea",
    name: "Rhea",
    role: "Integrated Optimization Agent",
    avatar: "https://cdn.jotfor.ms/assets/agent-avatars/avatar_icon_79.png",
    blurb:
      "Discuss your goals, current symptoms, and optimization priorities. Rhea guides you toward the right Integrated Wellness next step.",
    url: RHEA_URL,
    cta: "Launch Rhea",
  },
  intake: {
    id: "intake",
    name: "Get Started",
    role: "General Wellness Intake",
    avatar: null,
    blurb:
      "A guided form that captures your history, goals, and context — the foundation for a personalized care path.",
    url: ACTIVATION_URL,
    cta: "Open the form",
  },
};
